import { Feedback } from '../lib';
import { useDeleteEvaluation } from './use-delete-evaluation';
import { useResendEvaluation } from './use-resend-evaluation';

export const useFeedbackActions = (evaluation: Feedback) => {
	const destroy = useDeleteEvaluation();
	const resend = useResendEvaluation(evaluation);

	const handleDelete = () => {
		destroy.mutate(evaluation.id);
	};

	const handleResend = () => {
		resend.mutate();
	};

	return {
		deleteRequest: handleDelete,
		isDeleting: destroy.isLoading,
		isResending: resend.isLoading,
		resendRequest: handleResend,
	};
};
